var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Thinking_Face",
    "data-name": "Thinking Face"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m272 512c-65.6 0-134.63-35.971-189.389-98.69-51.728-59.247-82.611-133.01-82.611-197.31 0-66.7 29.044-122.683 83.991-161.887 48.909-34.895 115.677-54.113 188.009-54.113 66.7 0 128.262 27.927 173.342 78.636 42.358 47.652 66.658 112.299 66.658 177.364s-24.3 129.712-66.658 177.364c-45.08 50.709-106.642 78.636-173.342 78.636z",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.751 128.123c-6.379 173.32-148.872 311.877-323.751 311.877a326.3 326.3 0 0 1 -51.92-4.16c50.73 48.723 110.632 76.16 167.92 76.16 66.7 0 128.262-27.927 173.342-78.636 42.358-47.652 66.658-112.299 66.658-177.364a272.481 272.481 0 0 0 -32.249-127.877z",
    fill: "#ffb74d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.92 512a111.846 111.846 0 0 1 -111.92-111.92 131.083 131.083 0 0 1 33.649-87.7l41.21-45.79a32.035 32.035 0 0 1 23.771-10.59h.03a31.98 31.98 0 0 1 28.59 46.29l-.141.27-17.679 29.36v-.01a7.872 7.872 0 0 0 -1.14 4.06 8.215 8.215 0 0 0 2.279 5.61 7.774 7.774 0 0 0 5.741 2.42h136.83a26.948 26.948 0 0 1 19.04 8.02 27.836 27.836 0 0 1 8.34 18.81c0 .34.01.67.01.91a29.108 29.108 0 0 1 -7.62 19.45 26.25 26.25 0 0 1 -19.27 8.81h-48.69v18.97a92.952 92.952 0 0 1 -93.03 93.03z",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88 472a143.31 143.31 0 0 1 -76.158-21.777 111.822 111.822 0 0 0 100.078 61.777 92.952 92.952 0 0 0 93.03-93.03v-6.949a143.806 143.806 0 0 1 -116.95 59.979z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 148,
    fill: "#616161",
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 140,
    fill: "#fff",
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 128,
    fill: "#616161",
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 120,
    fill: "#fff",
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#cfcfcf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m204.95 400v16h-36.34a8 8 0 0 1 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.05 432a90.644 90.644 0 0 1 -3.73 16h-41.16a8 8 0 1 1 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.36 472a92.15 92.15 0 0 1 -10.66 12.75c-1.12 1.12-2.25 2.2-3.42 3.25h-36.07a8 8 0 0 1 0-16z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m128 92a8 8 0 0 1 -5.12-14.15c5.68-4.68 13.42-8.16 23.67-10.63a136.284 136.284 0 0 1 58.9 0c10.239 2.47 17.989 5.95 23.67 10.63a8 8 0 0 1 -10.24 12.3c-3.41-2.9-9.811-5.66-17.14-7.37a114.79 114.79 0 0 0 -25.71-2.78h-.06a114.881 114.881 0 0 0 -25.72 2.78c-7.32 1.71-13.72 4.47-17.13 7.37a8.027 8.027 0 0 1 -5.12 1.85z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 112a8 8 0 0 1 0-16c.02 0 .64 0 1.83-.01 1.09-.01 2.88-.04 5.2-.09 5.949-.14 11.94-.39 17.82-.73 12.94-.75 31.469-2.34 46.28-5.72 8.88-1.94 16.82-4.99 19.75-7.6a8 8 0 0 1 10.24 12.3c-7.16 5.79-16.94 8.66-26.45 10.9a262.091 262.091 0 0 1 -33.13 4.92c-20.75 1.91-39.41 2.02-41.471 2.03z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264 256h-48a8 8 0 0 1 0-16h48a8 8 0 0 1 0 16z",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m351.915 130.057c.051.641.085 1.288.085 1.943a23.983 23.983 0 0 1 -39.915 17.943 24 24 0 1 0 39.83-19.886z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.915 110.057c.051.641.085 1.288.085 1.943a23.983 23.983 0 0 1 -39.915 17.943 24 24 0 1 0 39.83-19.886z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 176,
    fill: "#ffe4c0",
    r: 24
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 176,
    fill: "#ffe4c0",
    r: 24
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOps);
export default __webpack_public_path__ + "static/media/ops.cb20ef91b2cf945b6dc54b9a680caa91.svg";
export { ForwardRef as ReactComponent };